<template>
<div>
<ContentHeader title="Yeni Soru Listesi Seçeneği"  url="QuestionlistGeneraloptions" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri" ></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<form @submit.prevent="submitForm" class="mt-4" v-if="languages.length">



<div class="grid mb-4" >
<div class="col-12 md:col-12">
<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>
</div>

<div class="col-12 md:col-12">
<InputSwitchValidate :data="fields[3]" :fieldindex="3" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>

<div class="col-12 md:col-12">
<InputNumberValidate :data="fields[1]" :fieldindex="1" @emitValue="inputValueEmitted"></InputNumberValidate>
</div>

<div class="col-12 md:col-12">
<InputSwitchValidate :data="fields[2]" :fieldindex="2" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>

<div class="col-12 md:col-12">
<InputSwitchValidate :data="fields[4]" :fieldindex="4" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>

<div class="col-12 md:col-12">
<InputColorPickerValidate  :data="fields[5]" :fieldindex="5" @emitValue="inputValueEmitted"></InputColorPickerValidate>
</div>


</div>
<hr class="mb-6">

<template v-if="show_translations">
<div class="grid" v-for="(item,index) in languages">
<div class="col-12 md:col-12">
<InputTextValidate :data="translationfields[index]" :fieldindex="index" @emitValue="translationValueEmitted"></InputTextValidate>
</div>

</div>  
</template>











<div class="flex justify-content-end flex-wrap mt-3">
 <Button label="Kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>



</form>
</template>

</div>
</template>

<script>
export default {

  name: 'QuestionlistOption',

  data () {
    return {      
    fields:[
      {
        title:"İsim",
        key:"name",
        type:"text",
        value:null,
        min_length:1,
        max_length:500,
        is_required:true,
        has_error:false,
        error_message:null,
        show:true,
      },
      {
        title:"puan %",
        key:"points",
        type:"number",
        value:0,
        is_required:false,
        steps:1,
        show:true
      },
      {
        title:"Seçildiğinde diğerlerinden seçimi kaldır",
        key:"disselect_all",
        type:"switch",
        value:false,
        show:true,
      },      
      {
        title:"Aktif",
        key:"active",
        type:"switch",
        value:false,
        show:true,
      },    
      {
        title:"Seçilirse Uygunsuzluk",
        key:"nonconformity_if_selected",
        type:"switch",
        value:false,
        show:true,
      },  
      {
        title:"Renk",
        key:"color",
        type:"color",
        value:false,
        show:true,
      },
      ],
      translationfields:[],
      languages:[],
      show_translations:false,
      item:null,
      loading:true,
    }
  },

  async mounted()
  {
    console.log(this.$store.state.questions.question)
    await this.getProjectLanguages()
    if(this.$route.params.option_id)
    {
      await this.getData()
    }
    this.loading = await false
  },
  methods:{
    async getData()
    {
      this.item = await this.generalApiGetWithoutLoader("questionlistoption/"+this.$route.params.option_id)
      console.log("iterm")
      console.log(this.item);
      
      await setTimeout(async ()=>{
        this.fields[0].value = await this.item.name
        this.fields[5].value = await this.item.color
        this.fields[1].value = await parseFloat(this.item.points)
        if(this.item.active)
        {

          this.fields[3].value = await true
        }
        else
        {
          this.fields[3].value = await false
        }
        if(this.item.disselect_all===1 )
        {
          this.fields[2].value = await true
        }
        if(this.item.nonconformity_if_selected ===1 )
        {
          this.fields[4].value = await true
        }

        for(let element of this.item.translations)
        {
          let ind = await this.translationfields.findIndex((item)=>{return item.language_id == element.language_id})
          
          this.translationfields[ind].value = await element.translation
          this.translationfields[ind].id = await element.id
        }
      })
      
      await console.log(this.translationfields)
    },
     async getProjectLanguages()
     {
      console.log(this.$store.state.questionlists.questionlist.project_id)
      this.languages = await this.generalApiGetWithoutLoader("project/languages/"+this.$store.state.questionlists.questionlist.project_id)
      console.log("languages")
      console.log(this.languages)
      for(let item of this.languages)
      {
        let obj = await 
          {
              title:item.name+" için çeviri",
              key:item.id,
              type:"text",
              language_id:item.id,
              value:null,
              is_required:true,
              has_error:false,
              error_message:null,
              show:true,
            }
       await this.translationfields.push(obj)
      }
      console.log(this.translationfields)
      this.show_translations = await true
     },
     submitForm()
    {
        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
        console.log(validated)
    },
    inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false
     
    },
    translationValueEmitted(data)
    {
      this.translationfields[data.index].value = data.value 
    },
    submit()
    {       
      let formdata = this.createFormData(JSON.parse(JSON.stringify(this.fields)))
      console.log(this.translationfields)
     //return false
      formdata.append("translations",JSON.stringify(this.translationfields))

      console.log(formdata)
      formdata.append("questionlist_id",this.$route.params.id) 
      if(this.$route.params.option_id)
      {
        this.generalSubmission(formdata,"questionlistoption/"+this.$route.params.option_id,this.afterSubmit)
      } 
      else
      {
        this.generalSubmission(formdata,"questionlistoption",this.afterSubmit)
      }
      
    },
    afterSubmit(response)
    {
        console.log(response)
        this.$router.push({ name: 'QuestionlistGeneraloptions'})
        
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>